export const STORAGE = {
  authToken: 'jwt_token',
  userEmail: 'user_email',
  confirmationToken: 'confirmation_token',
  resetToken: 'reset_password_token'
}
